
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.776 14.395L9.92.664a.968.968 0 00-1.838 0L.224 14.394c-.506.884-.126 1.607.843 1.607h15.865c.97-.001 1.35-.723.844-1.606zM10.84 4.5l-.917 5H8.09l-.917-5h3.667zm-1.834 9.67a1.827 1.827 0 112-1.817A1.916 1.916 0 019 14.17h.005z"}})])
          )
        }
      }
    